import { Component, OnInit } from '@angular/core';
import { Corporate } from '../model/corporate';
import { SharedService } from '../../../component/shared/shared.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { CorporateService } from 'app/section/master/services/corporate.service';
import { empty } from 'rxjs/Observer';
@Component({
  selector: 'app-mycorporate',
  templateUrl: './mycorporate.component.html',
  styleUrls: ['./mycorporate.component.css']
})
export class MycorporateComponent implements OnInit {
  corporateData :Corporate = new Corporate (null,'','',null,null,null,null);
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  corporates:any;
  selectedObject : Corporate;
  isAdd : boolean = true;
  user:any;
  corporateId:number;
  deActivedObject:Corporate;
  constructor(private _sharedService: SharedService,private _corpService:CorporateService) { 
    this.isAdd = true;
    _sharedService.yesEmitted$.subscribe(
       text => {
           if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'CORPORATE') {
               this.delete();
           }else if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'CORPORATE-STATUS'){
            this.deleted();
           }
            else {
               this.clearData();
           }
       });
  }
  
  clearData() : void {
    this.corporateData.CompanyName = "";
    this.corporateData.EmailExtension = "";
    this.corporateData.TotalAppt = null;
    this.corporateData.RemaningAppt = null;
    this.corporateData.CreateDate = null;
    this.corporateData.IsActive = null;
    this.isAdd = true;
}
saveCorporate() : void {
    this.loading = true;
    this._corpService.data = this.corporateData;
    if(this.isAdd){
      this.addCorporate();
    } else {
      this.updateCorporates();
    }
}
addCorporate() :void {    
    this._corpService.saveCorporate().subscribe(data=>{
      this.loading = false;
      this.message = "Corporate "+ ActionMessage.SAVESUCCESS.toString();
      this.clearData();
      this.getCorporates();
      this.hideMessage();
    },
    error=>{
        this.loading = false;
        if(error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
    });
} 
updateCorporates() :void {
  this.loading = true;
  this.corporateData.TAP_AUTOID = this.corporateId;
    this._corpService.saveCorporate().subscribe(data=>{
      this.loading = false;
      this.message = "Corporate "+ ActionMessage.UPDATESUCCESS.toString();
      this.clearData();
      this.getCorporates();
      this.hideMessage();
    },
    error=>{
        this.loading = false;
        if(error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
    });
} 
delete() : void {
    this.listLoading = true;
    this._corpService.deleteCorporate(this.selectedObject).subscribe(data=>{
      this.listLoading = false;
      this.message = "Corporate " + ActionMessage.DELETESUCCESS.toString();
      this.clearData();
      this.getCorporates();
      this.hideMessage();
    },
    error=>{
        this.listLoading = false;
        if(error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
    });
}
hideMessage() : void {
  setTimeout(() => {
  
    this.message = '';
  }, 1000);
}
cancelData() : void {
   if(this.isAdd) {
     this.clearData();
   } else {
     this._sharedService.emitDialog(true,"Cancel",ActionMessage.CANCEL.toString(),true, DialogAction.CANCEL.toString() ,'CORPORATE');
   }
     
}
deletCorporate(corp : Corporate) :void {
   this.selectedObject = corp;
   this._sharedService.emitDialog(true,"Delete",ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(),'CORPORATE' );   
}
editCorporates(corpEditObject : Corporate) : void {
  this.corporateId = corpEditObject.TAP_AUTOID;
   this.isAdd = false;
   this.corporateData = Object.assign(Object.create(corpEditObject), corpEditObject);
}

getCorporates(){
  this.listLoading = true;
  this._corpService.getAllCorporate().subscribe(data=>{
    this.listLoading = false;
  this.corporates = data
  },
  error=>{
      this.listLoading = false;
      this.message = error.data;
  });  
}
ngOnInit() {
  this.user = JSON.parse(sessionStorage.getItem("User"));
  this.getCorporates();
}
ngAfterViewChecked() {
   this._sharedService.emitChange(false);
}
ngOnDestroy() {
   this._sharedService.emitChange(true);
}
reActive(corp:Corporate){
  this.deActivedObject = corp;
   this._sharedService.emitDialog(true,"Re-Active",ActionMessage.REACTIVATE.toString(),true,DialogAction.REACTIVE.toString(),'CORPORATE-STATUS' );
}
deleted(){
  if(this.deActivedObject.TAP_AUTOID){
    this.listLoading = true;
    this._corpService.activeCorporate(this.deActivedObject).subscribe(data=>{
      this.listLoading = false;
      this.message = "Corporate " + ActionMessage.DELETESUCCESS.toString();
      this.clearData();
      this.getCorporates();
      this.hideMessage();
    },
    error=>{
        this.listLoading = false;
        if(error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
    });
}
}
}



// WEBPACK FOOTER //
// ./src/app/section/user/mycorporate/mycorporate.component.ts